export const questions = [
	{
		'title': 'How often should I get a DEXA scan?',
		'body': 'We recommend starting with a baseline scan and booking follow-up scans monthly or quarterly. Regular scans help you stay motivated, track your progress, and adjust your health and fitness routines to achieve your goals.'
	},
	{
		'title': 'How long does it take to get a DEXA scan?',
		'body': 'Less than 15 minutes! You\'ll get your personalized, comprehensive, total body measurement quickly and be on your way.'
	},
	{
		'title': 'Who should get a DEXA scan?',
		'body': 'Anyone that\'s interested in better health. A DEXA scan is a powerful tool that provides a comprehensive full-body snapshot and deep visibility into what\'s going on under your skin.'
	},
	{
		'title': 'Do I have to go to a BodySpec office?',
		'body': 'No - we also provide scans in our mobile clinics! BodySpec vans are equipped with DEXA machines to provide quick and convenient scans at your office, gym, local business or public space. If you\'re interested in hosting one of our vans, click [HERE](/work-with-us).'
	},
	{
		'title': 'Are DEXA scans safe?',
		'body': 'The amount of radiation from a DEXA scan is very low and very safe. Our average scan is equivalent to the radiation from eating 4 bananas.'
	},
	{
		'title': 'How accurate are DEXA scans?',
		'body': 'DEXA scans are the gold standard for measuring body composition as they use medical-grade technology that is both precise AND accurate. We run daily quality assurance testing on all our machines to ensure they achieve an accuracy of +/- 0.5% before testing any clients.'
	},
	{
		'title': 'How long will it take to receive my results?',
		'body': 'Usually within a few hours! We\'ll upload the scan results to your BodySpec account so they\'re always available and also email you a link to access via your Dashboard.'
	},
	{
		'title': 'Will someone explain my results to me?',
		'body': 'Yes! Join one of our FREE [Health Hangouts](/health-hangout) to get a detailed explanation of each section of the scan report from one of our DEXA experts.'
	}
];

export const bfcmQuestions = [
	{
		'title': 'How do I buy a gift card?',
		'body': 'Simply buy your gift credits and head to Transfer or share credits in your Account. You\'ll be able to enter all the details and select the gift card theme you\'d like to send. Even schedule it to be sent on a future date for special occasions or holidays.'
	},
	{
		'title': 'How will my gift card be delivered?',
		'body': 'Once you\'ve selected which gift card and how many credits you\'d like to send, we\'ll send an email to your friend with their unique gift card along with instructions for how to redeem. If you select a future date, we\'ll hold off until then to make the moment really special.'
	},
	{
		'title': 'How do I get help buying or redeeming a gift card?',
		'body': 'Our team is always here to help. Simply email us at support@bodyspec.com, call or chat with us and we\'d be happy to support you.'
	},
	{
		'title': 'How many gift cards can I send?',
		'body': 'As many as you\'d like! All you need is to purchase the credits with your BodySpec account login, and you\'ll be able to send the gift credits from your account under Transfer or share credits. You can send up to 4 credits within any one gift card.'
	},
];

export default questions;
